<template>
  <layout-basic>
    <v-container grid-list-md text-xs-left fluid style="padding: 0px">
      <v-layout row wrap>
        <v-col cols="12" md="3"></v-col>
        <v-col cols="12" md="6" class="mt-10">
          <!-- Skeleton loader -->
          <div v-if="loading">
            <v-skeleton-loader type="list-item-two-line" class="mb-4" v-for="n in 3" :key="n" />
          </div>
          <v-expansion-panels v-model="expandedPanel" multiple v-else>
            <v-expansion-panel v-for="(banding, index) in bandings" :key="banding.id" class="panel-spacing">
              <v-expansion-panel-header class="custom-header">
                {{ banding.name }}
              </v-expansion-panel-header>

              <v-expansion-panel-content class="custom-panel-content">
                <!-- Create Button -->
                <v-row justify="end" class="mb-4">
                  <v-btn small color="primary" @click="openCreateDialog(banding, index)">
                    Create Package
                  </v-btn>
                </v-row>
                <template v-if="banding.packages && banding.packages.length">

                  <!-- Packages List -->
                  <v-list two-line>
                    <v-list-item v-for="pkg in banding.packages" :key="pkg.id" class="package-item">
                      <v-list-item-content>
                        <v-list-item-title>{{ pkg.name }} <br /> 
                          <small>
                           <div class="text--secondary text-caption mt-1">
                            Max Courses Allowed: {{ pkg.maxCourses }}
                          </div>
                        </small></v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action class="actions">
                        <v-btn icon @click="openEditDialog(pkg, banding, index)">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn icon @click="deletePackage(pkg, index)">
                          <v-icon color="red">mdi-delete</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </template>

                <template v-else>
                  <div class="text-center grey--text py-4">
                    No packages available for this banding.
                  </div>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
        <v-col cols="12" md="3"></v-col>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialog" max-width="550px" scrollable persistent>
      <v-card>
        <v-card-title :class="this.$gf.headerColor()" style="color: white;">
          <span>{{ isEditMode ? 'Edit Package' : 'Create Package' }}</span>
        </v-card-title>


        <v-container class="dialog-container">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field label="Package Title" v-model="form.name" :error-messages="messages.title" filled
                class="input-width" required></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field label="Max Course Number" v-model="form.maxCourses" type="number" required :min="0"
                @keypress="NumbersOnly" @blur="handleMaxCourseBlur()" :error-messages="messages.max_course" filled
                class="input-width"></v-text-field>
            </v-col>
          </v-row>
        </v-container>


        <v-card-actions class="btn-section pa-5">
          <v-spacer></v-spacer>
          <template v-if="loadingBtn">
            <v-btn color="primary" loading></v-btn>
          </template>
          <template v-else>
            <v-btn color="primary" @click="closeDialog" class="add-course-button">Cancel</v-btn>
            <v-btn color="primary" @click="savePackage" class="add-course-button">
              {{ isEditMode ? 'Update' : 'Create' }}
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </layout-basic>
</template>
<script>
import LayoutBasic from '@/layouts/SuperAdmin';
import superAdminAPI from '@/api/superadmin.js';

export default {
  components: {
    LayoutBasic,
  },
  data() {
    return {
      bandings: [],
      messages: {},
      activeBanding: null,
      newPackage: {}, // to track new package names per banding
      dialog: false,
      isEditMode: false,
      form: {
        title: '',
        maxCourses: null,
        id: null,
        companyCount: 0
      },
      loading: false,
      successMessage: 'Package has been created successfully!',
      updateSuccessMessage: 'Package has been updated successfully!',
      deleteSuccessMessage: 'Pakage has been deleted successfully!',
      errorMessage: "Oops, something went wrong!",
      infoMsg: "This package is currently assigned to one or more companies. Since it is already in use, modifications are not allowed.",
      deleteInfoMsg: "This package is currently assigned to one or more companies. Only packages with no company assignments can be deleted.",
      confirmDelete: `Are you sure you wish to delete this package?`,
      companyCount: 0,
      expandedPanel: [], // index of open panel
      previousPanel: [],
      loadingBtn: false,
    };
  },
  mounted() {
    this.getBandingPackages();
  },
  computed: {

  },
  methods: {
    getBandingPackages() {
      this.loading = true;
      superAdminAPI
        .getBandingPackages()
        .then((res) => {
          this.loading = false;
          this.bandings = Object.values(res.data.bandings);
          if (this.previousPanel) {
            this.$nextTick(() => {
              this.expandedPanel = this.previousPanel;
              this.previousPanel = [];
            });
          }
        });
    },
    openCreateDialog(banding, index) {
      this.isEditMode = false;
      this.activeBanding = banding;
      this.previousPanel = [index]; // save current index
      this.form = {
        title: '',
        maxCourses: null,
        id: null,
      };
      this.dialog = true;
    },
    openEditDialog(pkg, banding, index) {
      this.isEditMode = true;
      this.activeBanding = banding;
      this.previousPanel = [index]; // save current index
      this.form = { ...pkg };
      this.companyCount = pkg.companyCount;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.companyCount = 0;
      this.messages = {}
    },
    deletePackage(pkg, index) {
      this.previousPanel = [index]; // save current index
      this.$snotify.confirm(this.confirmDelete, {
        backdrop: 0.3,
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.deletePackageProcess(toast, pkg),
          },
        ],
      });
    },
    deletePackageProcess(toast, pkg) {
      this.$snotify.remove(toast.id);
      if (pkg.companyCount > 0) {
        this.$snotify.confirm(this.deleteInfoMsg, {
          backdrop: 0.3,
          buttons: [
            { text: 'OKAY', className: 'toast-continue-button' },
          ],
        });
      } else {
        this.loading = true;
        superAdminAPI
          .deleteBandingPackage(pkg.id)
          .then((res) => {
            this.loading = false;
            this.$snotify.success(this.deleteSuccessMessage);
            this.getBandingPackages();
          });
      }
    },
    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode == 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    handleMaxCourseBlur() {
      const value = parseInt(this.form.maxCourses, 10);
      if (value == 0) {
        this.form.maxCourses = 1;
      }
      if (value > 999) {
        this.form.maxCourses = 999;
      }
    },
    savePackage() {
      if (!this.activeBanding) return;

      if (this.isEditMode) {
        const index = this.activeBanding.packages.findIndex(
          (p) => p.id === this.form.id
        );
        if (index !== -1) {
          if (this.form.companyCount > 0) {
            this.$snotify.confirm(this.infoMsg, {
              backdrop: 0.3,
              buttons: [
                { text: 'OKAY', className: 'toast-continue-button' },
              ],
            });
          } else {
            this.loadingBtn = true;
            superAdminAPI
              .updateBandingPackage(this.form)
              .then((res) => {
                this.loadingBtn = false;
                this.$snotify.success(this.updateSuccessMessage);
                this.getBandingPackages();
                this.closeDialog();
              }).catch(err => {
                this.messages = this.$gf.errorResponse(err);
                this.$snotify.error(this.errorMessage);
                this.loadingBtn = false;
              });
          }
        }
      } else {
        this.loadingBtn = true;
        this.form.banding_id = this.activeBanding.id;
        superAdminAPI
          .createBandingPackage(this.form)
          .then((res) => {
            this.loadingBtn = false;
            this.$snotify.success(this.successMessage);
            this.getBandingPackages();
            this.closeDialog();
          }).catch(err => {
            this.messages = this.$gf.errorResponse(err);
            this.$snotify.error(this.errorMessage);
            this.loadingBtn = false;
          });
      }
    }
  },
};
</script>
<style scoped>
.custom-header {
  background-color: #f5f5f5;
  /* light grey */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-weight: bold;
  color: #333;
  /* optional darker text */
}

.custom-panel-content {
  border: 1px solid #ddd;
  /* Light border */
  padding: 16px;
  /* Spacing */
  border-radius: 4px;
  /* Optional: rounded corners */
  background-color: #fafafa;
  /* Optional: light background */
  margin-top: 8px;
  /* Space from header */
}

.panel-spacing {
  margin-bottom: 12px;
  /* Adds space between panels */
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  /* Optional for visual separation */
}

.dialog-title {
  padding: 5px;
}

.btn-section {
  padding: 8px 16px !important;
}

.dialog-container {
  padding: 10px !important;
  overflow: hidden;
}

.actions {
  flex-direction: row
}

.package-item {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  margin-bottom: 12px;
  padding: 8px 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
</style>